import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AbstractTool} from 'app/tool-layer/class/abstract-tool';
import {SvgOptionInterface} from 'app/component/svg-input/svg-input.component';
import {SvgElementsEnum} from 'app/enum/svg.enum';

@Component({
    selector: 'app-dice',
    templateUrl: './dice.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DiceComponent extends AbstractTool {
    public static readonly id = 'dice';
    public static readonly width = 0;
    public static readonly height = 0;
    public static readonly settingsInstanceOnly = true;

    public svgList!: SvgOptionInterface[];

    constructor() {
        super();

        this.svgList = [
            SvgElementsEnum.Dice1,
            SvgElementsEnum.Dice2,
            SvgElementsEnum.Dice3,
            SvgElementsEnum.Dice4,
            SvgElementsEnum.Dice5,
            SvgElementsEnum.Dice6,
        ].map((path: SvgElementsEnum) => {
            return {path};
        });
    }
}
